import React from "react";
import "./style.css";
import { Skeleton } from "antd";

const Filterloader = () => {
  return (
      <div className="filterloader">
        <Skeleton.Input active size="default" />
        <Skeleton.Input active size="default" />
        <Skeleton.Avatar active size="default" shape="default" />
      </div>
  );
};

export default Filterloader;
